module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kd-Lb.352b4561.png";